<template>

  <div>
    <table class="modal-requeteIn">

      <tbody>
      <tr>
        <td class ="infoRequete col-lg-10 col-md-9">
          <p class="titreRequeteExecption pr-2"><strong>{{requete.titre}}</strong> : {{requete.message}}</p>
          <p class="titreRequeteExecption mt-3"><strong>{{requete.ligneAno}}</strong> anomalie(s) - <strong>{{requete.justif}}</strong> justifiées -
            <strong>{{requete.justifValid}}</strong> validées - <strong>{{requete.justifInvalid}}</strong> refusées
          </p>
        </td>
        <td class="btnRequete col-lg-2 col-md-3" title= "visualiser les lignes anomalies de la requête">
          <b-button pill @click.prevent ="handleShowModalAnomalieIn(idExecution,requete.idRequete)" align-self="center"
                    class="nav-link1">anomalies <i class="fas fa-arrow-alt-circle-down"></i>
          </b-button>
        </td>
      </tr>
      </tbody>

      <div v-if="showModalAnomalieIn!==false" class="col-md-12">
        <div v-if="anomalies.length!==0">
          <ModalAnomalieInRequeteWithoutConnexion
              :idExecution="idExecution"
              :idRequete="requete.idRequete"
              :anomalies="anomalies"
              :nomChamps = "nomChamps"
              class="col-md-12">
          </ModalAnomalieInRequeteWithoutConnexion>
        </div>
      </div>

    </table>
  </div>

</template>

<script>
import useRequeteItemWithoutConnexion from "@/composition/RapportsSansConnexion/requetesInExecution";
import ModalAnomalieInRequeteWithoutConnexion from '@/components/RapportSansConnexion/AnomalieFromRequeteWithoutConnexion.vue';
export default {
  name: 'RequeteItem',

  components:{
    ModalAnomalieInRequeteWithoutConnexion,
  },

  props: {
    requete:{
      required:true,
      type:Object
    },
    idExecution:{
      type:Number
    }
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props){
    return useRequeteItemWithoutConnexion(props);
  },
};

</script>

<style>
.nav-link1{
  color: white !important;
  font-size: 25px;
}
.nav-link1:hover{
  color: black !important;
}
.titreRequeteExecption{
  color: black;
  font-size: 13px;
}

.infoRequete{
  padding-right: 20px;
  padding-left: 20px;
}

.modal-requeteIn {
  border-radius: 10px;
  background-color: white;
  min-width: 100%;
}
</style>